import { co2 } from './common';

export default {
  'consumption.co2': `${co2} Emisiones combinadas`,
  'consumption.energy': 'Consumo combinado eléctrico',
  'consumption.fuel': 'Consumo combinado de combustible',
  'footnotes.local': '',
  'footnotes.wltp': `Los valores indicados han sido determinados según el procedimiento de medición prescrito. Se trata de «valores de emisiones de ${co2} WLTP» según el art. 2, apartado 3, del Reglamento de Ejecución (UE) 2017/1153. El consumo de combustible se ha calculado en base a dichos valores. El consumo de corriente se ha determinado sobre la base del Reglamento 683/2008/CE. Los datos no hacen referencia a un vehículo en particular y no forman parte integrante de la oferta, sino que sirven solamente para comparar entre sí los diferentes modelos. Los valores varían en función de los equipos opcionales elegidos.`,
  'footnotes.nedc': '', // `Los valores de ${co2} indicados han sido obtenidos de acuerdo con el procedimiento de ensayo “NEDC ${co2}“ según lo dispuesto en el art. 2 No1 Reglamento de aplicación (UE) 2017/1153.`
  'footnotes.emissions.appendix': '', // `Los datos no se refieren a un vehículo en particular y no forman parte de una oferta, sino que únicamente sirven para establecer comparativas entre distintos modelos. Para más información acerca del consumo de combustible oficial y de las emisiones de ${co2} se puede consultar la 'Guía de consumo de combustible y emisiones de ${co2} de nuevos vehículos' que está disponible sin coste en todos los puntos de venta y en IDAE en www.idae.es.`,
  'search.input.label': 'Tu búsqueda / Código online del configurador',
  'search.result.buy-online': 'Compra online',
  'search.results': 'No se han encontrado resultados | {count} resultado | {count} resultados',
  'search.results.count': ' {count} resultados',
  'search.results.backup': 'No se han encontrado coincidencias exactas. Ver páginas relacionadas:',
  'search.results.none.summary':
    'No hay resultados disponibles para este término de búsqueda. Inténtalo de nuevo con otro término de búsqueda.',
  'search.show-more': 'Ver más resultados',
  'search.unavailable': 'La búsqueda no está disponible actualmente.',
  'search.result.new': 'Nuevo',
  'input.placeholder': 'Tu búsqueda / Código online del configurador',

  'suggestions.all_search_results': 'Todos los resultados de búsqueda',
  'suggestions.all_search_results_for': 'Mostrar todos los resultados para',
  'suggestions.in': 'en',

  all: 'Todos',
  UCOS: 'Tienda en línea de autos usados',
  PASSENGER_CARS: 'Automóviles',
  VANS: 'Vans',
  NCOS: 'Tienda online de coches nuevos',
  VIDEO: 'vídeos',
  DEALER_LOCATOR: 'Búsqueda de concesionarios',
  CONFIGURATOR: 'Configura tu vehículo',
  TEST_DRIVE: 'Prueba de conducción',
  VEHICLE_SEARCH: 'Búsqueda de vehículos',
  COLLECT: 'Accesorios y coleccionables',
  CONNECT: 'Tienda Mercedes me',
  ACCESSORIES: 'Accesorios de coche',

  'search.result.consumption': 'Consumo',
  'watch.video': 'Vea el vídeo',
  'input.recently': 'Buscado recientemente',
  'input.help.title': '¿Qué puedes buscar?',
  'input.help.text':
    'Puedes realizar búsquedas indicando el tipo de vehículo, el modelo, códigos de configuración o bien buscar accesorios, otros productos e información',

  // No results found
  'support.check':
    'Comprueba que no has cometido errores de ortografía, o inténtalo de nuevo con un término diferente.',
  'support.no.results': 'No hay resultados disponibles para este término de búsqueda.',
  'support.no.results.term': 'No se ha encontrado ningún resultado',
  'support.chat': '¿No has encontrado lo que estabas buscando? Acude a nuestro servicio de asistencia por',
  'support.chat.with.us': 'conversación online',
};
